import * as React from 'react'

const NavigationBack = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.338 21.716l-9.052-9.03a.969.969 0 010-1.373l9.052-9.029a.977.977 0 011.377 0 .97.97 0 010 1.374L8.352 12l8.363 8.342a.97.97 0 010 1.374.977.977 0 01-1.377 0z" />
  </svg>
)

export default NavigationBack
